export default __webpack_public_path__ + "static/matt_bw-709a24cc34fcd7449f2a10c7a42f79b8.png";